import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=399b3d4c&scoped=true"
import script from "./order-list.vue?vue&type=script&lang=js"
export * from "./order-list.vue?vue&type=script&lang=js"
import style0 from "./order-list.vue?vue&type=style&index=0&id=399b3d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b3d4c",
  null
  
)

export default component.exports